
import { EFilter, EProjectType, ESearchPageType } from '@/helpers/enums'
import { searchProjects } from '@/helpers/search'

const TOTAL_VISIBLE_RESULTS = 8

export default {
  name: 'Pool',
  layout: 'portal',
  auth: false,

  middleware: [
    'public-search-disabled',
    ({ app, $auth, redirect, params }) => {
      if ($auth.loggedIn) {
        redirect(app.$link.pool(params.id))
      }
    }
  ],

  async asyncData({ app, store, route, params, redirect, error }) {
    const allPools = await store.state.publicSearch.allPools
    const checkId = allPools.filter((item) => item.id === Number(params.id))
    const imageArr = checkId[0].images

    if (!checkId.length) {
      return redirect(app.$link.projectSearch())
    }

    try {
      const { currentOffset, results, total } = await searchProjects({
        pageSize: TOTAL_VISIBLE_RESULTS,
        context: app,
        type: EProjectType.PUBLIC,
        typedQuery: ESearchPageType.POOLS,
        route
      })

      if (currentOffset && currentOffset >= total) {
        app.$resetPage(route.query)
      }

      store.commit('SEO_INDEX', total !== 0)

      return {
        pageImages: imageArr.length ? imageArr : [],
        pageName: checkId[0].poolNameVerbiage,
        pageDescription: checkId[0].poolDescriptionVerbiage,
        listResults: results,
        listResultsTotal: total,
        currentOffset
      }
    } catch (err) {
      error({
        statusCode: err.response?.status,
        message: err.response?.statusText
      })
    }
  },

  head() {
    const client = this.$store.state.clientContext.name
    return this.$headMetaTags({
      title: this.$t('talent.global.search.pool.meta.title', {
        pool: this.$t(this.pageName),
        client: this.$capitalize(client)
      }),
      keywords: this.$t('talent.global.search.pool.meta.keywords', {
        pool: this.$t(this.pageName),
        client: this.$capitalize(client)
      }),
      description: this.$t('talent.global.search.pool.meta.description', {
        pool: this.$t(this.pageName),
        client: this.$capitalize(client)
      })
    })
  },

  computed: {
    bannerTitle() {
      return this.$t('talent.global.search.pools.title', {
        pool: this.$t(this.pageName)
      })
    },

    totalVisible() {
      return TOTAL_VISIBLE_RESULTS
    }
  },

  watchQuery: [EFilter.PAGE]
}
